import { Route, Routes } from 'react-router-dom';

import { AcademicoGraduacaoRoutes } from './Graduacao';
import { AcademicoPosGraduacaoRoutes } from './PosGraduacao';
import { DetalhesSolicitacao } from '@/pages/DetalhesSolicitacao';
import { GradeHorario } from '@/pages/GradeHorario';
import { AcademicoExtensaoRoutes } from './Extensao';


const AcademicoRoutes = () => {
    return (
        <Routes>
            <Route path='/graduacao/*' element={<AcademicoGraduacaoRoutes />} />

            <Route path='/pos-graduacao/*' element={<AcademicoPosGraduacaoRoutes />} />

            <Route path='/extensao/*' element={<AcademicoExtensaoRoutes />} />

            <Route path='/protocolo/solicitacoes/:id' element={<DetalhesSolicitacao />} />
            <Route path='/disciplinas/grade-horario' element={<GradeHorario />} />
        </Routes>
    );
}

export { AcademicoRoutes };